import React from "react";
import { HashLink as Link } from "react-router-hash-link";
import Home from "./Home";

//

class Misc extends React.Component {
  render() {
    return (
      <div className="Misc">
        <>
          <div className="ButtonMenu">
            <Link to="../Home#about">
              <button className="Menu">&#60;About&#62;</button>
            </Link>
            <Link to="../Home#work">
              <button className="Menu">&#60;Work&#62;</button>
            </Link>
            <button>
              <Link to="../Home#contact" className="Menu">
                &#60;Contact&#62;
              </Link>
            </button>
          </div>

          <div id="centered">
            {" "}
            <h1 classname="workdescription">05_Misc</h1>{" "}
          </div>
        </>
        <div className="workbody">
          <div className="gridexp">
            <figure className="cell cell--video5">
              <video
                muted
                loop
                autoPlay
                webkit-playsInline
                playsInline
                className="img_gallery"
              >
                <source src="/img/elephant.mov" type="video/mp4" />
              </video>
              <p className="appear">Animation using After Effects</p>
            </figure>

            <figure className="cell cell--video6">
              <video
                muted
                loop
                autoPlay
                webkit-playsInline
                playsInline
                className="img_gallery"
              >
                <source src="/img/clothanim.mp4" type="video/mp4" />
              </video>
              <p className="appear">Layered 3D garment design</p>
            </figure>

            <a
              href="https://www.behance.net/gallery/206796905/BOOKSTORE-WINDOW-GRAPHICS"
              target="_blank"
              rel="noopener noreferrer"
              className="cell cell--31"
            >
              <figure className="img_gallery">
                <img src="/img/bookjewel.png" className="img_gallery" />
                <p className="appear">BookJewel Storefront Design</p>
              </figure>
            </a>

            {/* <figure className="cell cell--32">
              <img src="/img/device.png" className="img_gallery" />
              <p className="appear">Solar Walkman sci-fi device</p>
            </figure> */}

            <a
              href="https://www.fab.com/listings/1488d1a8-c41b-4115-abbb-5e1b94bcb1b9"
              target="_blank"
              rel="noopener noreferrer"
              className="cell cell--33"
            >
              <img src="/img/claypots.jpg" className="img_gallery" />
              <p className="appear">Clay Pots 3D Asset Pack</p>
            </a>

            <a
              href="https://www.artstation.com/artwork/oJbBdB"
              target="_blank"
              rel="noopener noreferrer"
              className="cell cell--34"
            >
              <figure className="img_gallery">
                <img src="/img/ukr_env.jpg" className="img_gallery" />
                <p className="appear">Kyiv City Courtyard Environment in UE5</p>
              </figure>
            </a>

            <figure className="cell cell--35">
              <img src="/img/vest.jpg" className="img_gallery" />
              <p className="appear">Puffer Vest: 3D garment design</p>
            </figure>

            <a
              href="https://www.fab.com/listings/0eb82e05-3cf0-4470-ad94-084b1f7c92cb"
              target="_blank"
              rel="noopener noreferrer"
              className="cell cell--36"
            >
              <figure className="img_gallery">
                <img src="/img/iron.jpg" className="img_gallery" />
                <p className="appear">Ironwork Pack 30+ 3D Assets</p>
              </figure>
            </a>

            <a
              href="https://www.behance.net/gallery/182442509/PRIMITIV-TYPEFACE"
              target="_blank"
              rel="noopener noreferrer"
              className="cell cell--37"
            >
              <figure className="img_gallery">
                <img src="/img/primitiv.png" className="img_gallery" />
                <p className="appear">PRIMITIV typeface</p>
              </figure>
            </a>

            <figure className="cell cell--38">
              <img src="/img/collab.jpg" className="img_gallery" />
              <p className="appear">Collaboration artwork with Ap0cene</p>
            </figure>
            <figure className="cell cell--39">
              <img src="/img/STATUE3.jpg" className="img_gallery" />
              <p className="appear">Poster design from my 3D scan</p>
            </figure>
            <figure className="cell cell--40">
              <img src="/img/trident.jpg" className="img_gallery" />
              <p className="appear">
                ВОЛЯ / FREEDOM Silver pendant <br />
                <br /> Designed and polished by me
              </p>
            </figure>

            <a
              href="https://www.artstation.com/artwork/QXAzeB"
              target="_blank"
              rel="noopener noreferrer"
              className="cell cell--41"
            >
              <figure className="img_gallery">
                <img src="/img/hut.jpg" className="img_gallery" />
                <p className="appear">Witch Hut Environment in UE5</p>
              </figure>
            </a>

            <figure className="cell cell--42">
              <img src="/img/stylized.jpg" className="img_gallery" />
              <p className="appear">Stylized Environment in Blender</p>
            </figure>
          </div>
        </div>
      </div>
    );
  }
}

export default Misc;
